import { useState } from 'react';
import { useTheme } from 'styled-components';

import MobileHeader from './MobileHeader';
import Sidebar from './SideBar';

const MobileHead = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenNav = () => {
    setIsOpen((prev) => !prev);
  };
  const theme = useTheme();
  return (
    <div
      style={{
        position: 'sticky',
        top: '0px',
        zIndex: theme.zIndices.header,
        backgroundColor: '#fff',
      }}
    >
      <MobileHeader open={isOpen} onClick={handleOpenNav} />
      <Sidebar Open={isOpen} setOpen={setIsOpen} />
    </div>
  );
};

export default MobileHead;
